/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockRecipeImagemanageCtrl
 */
angular.module('mercury.modules.stock.recipe')
.controller('StockRecipeImagemanageCtrl', ["dialog", "authService", "$http", "$q", "$scope", "$timeout", "$state", "ngJcropConfig", "onAdd", "onSelect", "onDelete", "recipe", "settings", function(dialog, authService, $http, $q, $scope, $timeout, $state, ngJcropConfig, onAdd, onSelect, onDelete, recipe, settings) {
  $scope.cropImage = null;

  ngJcropConfig.default.jcrop.aspectRatio = 4 / 3;
  ngJcropConfig.default.jcrop.maxWidth = 700;
  ngJcropConfig.default.jcrop.maxHeight = 390;

  $scope.flowConfig = {
    target: settings.apiHost + '/r/Image' + (recipe.id ? '?recipeId=' + recipe.id : '')
  };

  $scope.selected = 0;
  $scope.images = recipe.imagesJson;

  var loadingPromises = [];
  angular.forEach($scope.images, function(image) {
    var loadingPromise = $http({url: settings.apiHost + '/r/Image/' + image.id, method: 'GET', responseType: 'text', params: {recipeId: recipe.id}});
    loadingPromise.then(function(response) {
      image.src = 'data:image/png;base64,' + response.data;
    });
    loadingPromises.push(loadingPromise);
  });

  $scope.loadingImages = $q.all(loadingPromises);

  /**
  * Callback for when the selection on jcrop is removed
  */
  ngJcropConfig.default.jcrop.onRelease = function() {
    $timeout(function() {
      $scope.cropImage.crop = [];
    }, 50);
  };

  /**
  * Callback for clicking on image thumbnail. Change the selected image.
  */
  $scope.setSelected = function(index) {
    $scope.selected = index;
  };

  /**
  * Callback for the 'Close' button
  */
  $scope.closeImageDialog = function() {
    delete $scope.selected;
  };

  /**
  * Callback for starting the upload of all selected files.
  */
  $scope.uploadStarted = function() {
    $scope.imageUploading = $q.defer();
  };

  /**
  * Callback for completing the upload of all selected files
  */
  $scope.uploadComplete = function() {
    $scope.imageUploading.resolve();
    $scope.imageUploading = null;
  };

  /**
  * Callback for a successful image upload using flowjs
  */
  $scope.imageUploaded = function(message) {
    var uploadResponse = JSON.parse(message);

    $http({url: settings.apiHost + '/r/Image/' + uploadResponse.id, method: 'GET', responseType: 'text', params: {recipeId: recipe.id}})
    .then(function(response) {
      uploadResponse.src = 'data:image/png;base64,' + response.data;
      $scope.images.push(uploadResponse);
      $scope.selected = $scope.images.length - 1;

      onAdd($scope.images);
    });
  };

  /**
  * Callback for a failed image upload using flowjs
  */
  $scope.imageUploadFailed = function(message) {
    var response = JSON.parse(message);

    if (response.message) {
      dialog.alert(response.message);
    } else {
      dialog.alert('Unable to upload this image');
    }
  };

  /**
  * Callback for the 'Delete Image' button. Remove the image and it nessacary, update the main image.
  */
  $scope.removeSelectedImage = function() {
    var image = $scope.images[$scope.selected];

    onDelete(image);

    $scope.images.splice($scope.selected, 1);

    if (!$scope.images[$scope.selected]) {
      $scope.selected--;
    }
  };

  /**
  * Callback for the 'Select' button. Copy the selected image into the cropImage model
  */
  $scope.moveToCrop = function() {
    var cropImage = angular.copy($scope.images[$scope.selected]);

    ngJcropConfig.default.trueSize = [cropImage.imageWidth, cropImage.imageHeight];

    if (cropImage.imageWidth < (cropImage.imageHeight / 0.75)) {
      cropImage.crop = [
        0,
        (cropImage.imageHeight - cropImage.imageWidth * 0.75) / 2,
        cropImage.imageWidth,
        cropImage.imageWidth * 0.75,
        cropImage.imageWidth,
        cropImage.imageWidth * 0.75
      ];
    } else {
      cropImage.crop = [
        (cropImage.imageWidth - cropImage.imageHeight / 0.75) / 2,
        0,
        cropImage.imageHeight / 0.75,
        cropImage.imageHeight,
        cropImage.imageHeight / 0.75,
        cropImage.imageHeight
      ];
    }

    $scope.cropImage = cropImage;
  };

  /**
  * Callback for the 'Confirm' button. Copy the cropImage into the main image field of the recipe.
  */
  $scope.confirmCrop = function() {
    var selectedCrop = angular.copy($scope.cropImage);
    $http({
      url: settings.apiHost + '/r/Image/' + $scope.cropImage.id,
      method: 'GET',
      responseType: 'text',
      params: {
        recipeId: recipe.id,
        cropX: $scope.cropImage.crop[0],
        cropY: $scope.cropImage.crop[1],
        cropW: $scope.cropImage.crop[4],
        cropH: $scope.cropImage.crop[5]
      }
    })
    .then(function(response) {
      selectedCrop.src = 'data:image/png;base64,' + response.data;
      onSelect(selectedCrop);
      $scope.$close();
    });
  };

  /**
  * Callback for cancelling the crop selection.
  */
  $scope.cropBack = function() {
    $scope.cropImage = null;
  };
}]);
